import api from "./api";

const DashboardAPI = {
    getDatas: (id) => api.get(`/dashboard/data/all`),
    getImport: () => api.get(`/dashboard/import`)
};

export default DashboardAPI;